import React from "react";
import CataloguePage from "../catalogue-page/CataloguePage";

const HouseHoldCatalogue: React.FC = () => {
  return (
    <CataloguePage
      heading="Householding"
      description="Find essential household items to make your daily life easier and more efficient."
      categoryFilter="household"
    />
  );
};

export default HouseHoldCatalogue;
